var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16669 8.00065C6.16669 7.63246 6.46516 7.33398 6.83335 7.33398H18.8334C19.2015 7.33398 19.5 7.63246 19.5 8.00065C19.5 8.36884 19.2015 8.66732 18.8334 8.66732H6.83335C6.46516 8.66732 6.16669 8.36884 6.16669 8.00065Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5001 5.99935C11.3232 5.99935 11.1537 6.06959 11.0287 6.19461C10.9036 6.31964 10.8334 6.4892 10.8334 6.66602V7.99935C10.8334 8.36754 10.5349 8.66602 10.1667 8.66602C9.79854 8.66602 9.50006 8.36754 9.50006 7.99935V6.66602C9.50006 6.13558 9.71078 5.62687 10.0858 5.2518C10.4609 4.87673 10.9696 4.66602 11.5001 4.66602H14.1667C14.6972 4.66602 15.2059 4.87673 15.5809 5.2518C15.956 5.62687 16.1667 6.13558 16.1667 6.66602V7.99935C16.1667 8.36754 15.8683 8.66602 15.5001 8.66602C15.1319 8.66602 14.8334 8.36754 14.8334 7.99935V6.66602C14.8334 6.4892 14.7632 6.31964 14.6381 6.19461C14.5131 6.06959 14.3435 5.99935 14.1667 5.99935H11.5001ZM8.16673 7.33268C8.53492 7.33268 8.83339 7.63116 8.83339 7.99935V17.3327C8.83339 17.5095 8.90363 17.6791 9.02866 17.8041C9.15368 17.9291 9.32325 17.9993 9.50006 17.9993H16.1667C16.3435 17.9993 16.5131 17.9291 16.6381 17.8041C16.7632 17.6791 16.8334 17.5095 16.8334 17.3327V7.99935C16.8334 7.63116 17.1319 7.33268 17.5001 7.33268C17.8683 7.33268 18.1667 7.63116 18.1667 7.99935V17.3327C18.1667 17.8631 17.956 18.3718 17.5809 18.7469C17.2059 19.122 16.6972 19.3327 16.1667 19.3327H9.50006C8.96963 19.3327 8.46092 19.122 8.08585 18.7469C7.71077 18.3718 7.50006 17.8631 7.50006 17.3327V7.99935C7.50006 7.63116 7.79854 7.33268 8.16673 7.33268Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 10.666C11.8682 10.666 12.1667 10.9645 12.1667 11.3327V15.3327C12.1667 15.7009 11.8682 15.9993 11.5 15.9993C11.1319 15.9993 10.8334 15.7009 10.8334 15.3327V11.3327C10.8334 10.9645 11.1319 10.666 11.5 10.666Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 10.666C14.5349 10.666 14.8334 10.9645 14.8334 11.3327V15.3327C14.8334 15.7009 14.5349 15.9993 14.1667 15.9993C13.7985 15.9993 13.5001 15.7009 13.5001 15.3327V11.3327C13.5001 10.9645 13.7985 10.666 14.1667 10.666Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.9638569b62604db2a09bcb13132267c5.svg";
export { ForwardRef as ReactComponent };